<template>
    <svg class='svg svg--nav svg--nav--line-center' preserveAspectRatio='none' width='52' height='10' viewBox='0 0 52 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <line x1='26' y1='0' x2='26' y2='10' class='svg--nav__stroke' stroke-width='0.5' vector-effect='non-scaling-stroke' />
    </svg>
</template>